import { Route } from '@angular/router';
import { CanvasHomeComponent } from './canvas/home/canvas-home.component';
import { MapsHomeComponent } from './canvas/maps/maps-home/maps-home.component';
import { ChartsHomeComponent } from './canvas/charts/charts-home.component';

export const CanvasRoutes: Route[] = [
  {
    path: '',
    component: CanvasHomeComponent,
    children: [
      {
        path: '',
        redirectTo: 'maps',
        pathMatch: 'full',
      },
      {
        path: 'home',
        redirectTo: 'maps',
        pathMatch: 'full',
      },
      {
        path: 'maps',
        component: MapsHomeComponent,
        data: {
          title: 'Canvas — Maps',
          description: 'Visualise and explore geospatial data on interactive maps',
        },
      },
      {
        path: 'charts',
        component: ChartsHomeComponent,
        data: {
          title: 'Canvas — Charts',
          description: 'Visualise and explore data with interactive charts',
        },
      },
    ],
  },
];
